import React from 'react';
import './convocatoria.css';

import { DialogTitle, Dialog, DialogActions, DialogContent } from '@mui/material';
import { useContext, useState, useEffect } from 'react';
//import { BsFillFileEarmarkPdfFill } from 'react-icons/bs';
import { BsFillChatDotsFill } from 'react-icons/bs';
import { axiosPublic, axiosPdf } from '../../helpers/axios';
import { GiArchiveRegister } from 'react-icons/gi';
import { FaUserCircle } from 'react-icons/fa';
import { block, unblock } from '../../helpers/loading';
import { FichaContext } from '../../context/FichaContext';
import Swal from 'sweetalert2';

import { useNavigate } from 'react-router-dom';
import { RouteContext } from '../../context/RouteContext';

var moment = require('moment');

const Convocatoria = () => {
	const [convoca, setConv] = useState([]);
	const { data, setData } = useContext(FichaContext);
	const { setConvocatoria } = useContext(RouteContext);
	const { convocatoria } = data;
	const { idconvocatoria } = convocatoria;
	const [reimprimir, setReimprimir] = useState(false);
	const [aspirante_id, setAspirante_id] = useState('');
	const [clave, setclave] = useState('');
	const navigate = useNavigate();

	const cleanFields = () => {
		setclave('');
		setAspirante_id('');
	};

	const handleIncribirse = (id) => {
		setData({
			...data,
			convocatoria: {
				...convocatoria,
				idconvocatoria: id,
				pagina: 1,
			},
		});
	};

	const handlePdfIcon = (id) => {
		setReimprimir(true);
		setData({
			...data,
			convocatoria: {
				...convocatoria,
				idconvocatoria: id,
			},
		});
	};

	const handleLogin = (id) => {
		setConvocatoria(id);
		navigate('/auth/login');
	};

	const reimprimirPdf = async () => {
		block();
		setReimprimir(false);
		const resp = await axiosPdf('reimprimirPdf', { aspirante_id, clave, idconvocatoria });
		const pdf = new File([resp.data], 'Comprobante.pdf', { type: 'application/pdf' });
		window.open(URL.createObjectURL(pdf), '_blank');
		unblock();
	};

	const handleReimprimirClick = async () => {
		block();
		try {
			const { data } = await axiosPublic('validaInscripcion', {
				identidad: aspirante_id,
				id_convocatoria: idconvocatoria,
				clave,
			});
			if (data['success']) {
				reimprimirPdf();
				cleanFields();
			} else {
				unblock();
				setReimprimir(false);
				Swal.fire({
					title: 'Error',
					text: data['msg'],
					icon: 'error',
					backdrop: true,
					allowOutsideClick: false,
					didClose: () => {
						setReimprimir(true);
						cleanFields();
					},
				});
			}
		} catch (error) {
			console.log(error.response);
			unblock();
			Swal.fire('Error', 'Algo salió mal', 'error');
		}
	};

	useEffect(() => {
		block();
		axiosPublic('convocatorias')
			.then((response) => {
				setConv(response.data.convocatorias);
				if (response.data.success) {
					unblock();
					if (response.data.convocatorias.length === 0) {
						Swal.fire({
							text: 'No hay convocatorias activas',
							icon: 'info',
							backdrop: true,
							allowOutsideClick: false,
							didClose: () => {
								window.location.href = 'https://www.upnfm.edu.hn/';
							},
						});
					}
					setConv(response.data.convocatorias);
				}
			})
			.catch((error) => {
				unblock();
				console.log(error);
				const data = error.response.status;
				Swal.fire('Error', data.msg, 'error');
			});
	}, []);

	return (
		<div className="body">
			{convoca.length >= 1 && (
				<div className="conv">
					<h3 className="ctitulo card-header">Convocatorias</h3>
					{convoca.map((convoca) => (
						<div className="col-sm-5" key={convoca.id}>
							<div className="card text-center">
								<div className="card-body">
									<h5 className="card-title">{convoca.descripcion}</h5>
									<p className="card-text">
										{moment.utc(convoca.fecha_inicio).format('DD/MM/YYYY')}&nbsp;-&nbsp;
										{moment.utc(convoca.fecha_final).format('DD/MM/YYYY')}
									</p>
									<div className="conv_btngroup d-flex flex-column">
										<button
											className="btnc btn btn-primary"
											onClick={() => handleIncribirse(convoca.id)}
											hidden={moment(convoca.fecha_final).isBefore(moment()) ? true : false}
										>
											<GiArchiveRegister />
											&nbsp;&nbsp;Inscribirse
										</button>
										{/* <button
											className="btnc btn btn-primary"
											onClick={() => handlePdfIcon(convoca.id)}
										>
											<BsFillFileEarmarkPdfFill />
											&nbsp;&nbsp;Comprobante
										</button> */}

										<button
											className="btnc btn btn-primary"
											onClick={() =>
												(window.location.href =
													'https://web.upnfm.edu.hn/chat/index.php/esp/chat/start/(operator)/2')
											}
										>
											<BsFillChatDotsFill />
											&nbsp;&nbsp;Chat informativo
										</button>
										<button
											className="btnc btn btn-primary"
											onClick={() => handleLogin(convoca.id)}
										>
											<FaUserCircle />
											&nbsp;&nbsp;Iniciar Sessión
										</button>
									</div>
								</div>
							</div>
						</div>
					))}
				</div>
			)}
			<div className="footerconv">
				<p>
					Universidad Pedagógica Nacional Francisco Morazán, Colonia el Dorado, Frente a Plaza Miraflores
					<br />
					Fax. 2231-1257 Tel. 2239-8842/2235-8349/2239-8002/2235-6062
					<br />
					&copy;Copyright 2022. All Rights Reserved
				</p>
			</div>

			<Dialog open={reimprimir}>
				<DialogTitle>Reimprimir Comprobante</DialogTitle>

				<DialogContent>
					<div className="txtfloat form-floating">
						<input
							className="form-control txt"
							type="text"
							name="aspirante_id"
							maxLength={15}
							placeholder="escribir"
							onChange={({ target }) => setAspirante_id(target.value)}
						/>
						<label className="lb">ID o pasaporte (sin guiones):</label>
					</div>
					<div className="txtfloat form-floating">
						<input
							className="form-control txt"
							type="number"
							name="clave"
							min="0"
							maxLength={10}
							placeholder="escribir"
							onChange={({ target }) => setclave(target.value)}
						/>
						<label className="lb">Clave:</label>
					</div>
				</DialogContent>

				<DialogActions sx={{ marginRight: 3 }}>
					<button
						type="button"
						className="btn btn-secondary"
						onClick={() => {
							setReimprimir(false);
							cleanFields();
						}}
					>
						Cancelar
					</button>
					<button type="button" className="btn btn-primary" onClick={handleReimprimirClick}>
						Reimprimir
					</button>
				</DialogActions>
			</Dialog>
		</div>
	);
};
export default Convocatoria;
